/**
 * Fila de conferencia agrupada por pessoa (spec 040, a virada da Global): um cartao por pessoa, com o nome, o documento e
 * os selos dela no topo, e um item por coisa a decidir (um plano, uma conta). Quem tem cinco planos aparece uma vez,
 * com os cinco embaixo, em vez de cinco linhas soltas numa tabela.
 *
 * Nao sabe a marca nem o que e plano: o app manda os textos, os fatos, as marcas e os botoes.
 */
import type { ReactNode } from "react";
import { Fatos, type Fato } from "./Pagina";

/** O cartao da pessoa. `aviso` fica entre o topo e os itens (ex.: o que impede de aprovar qualquer item dela). */
export function GrupoDaFila({ titulo, documento, apoio, selos, aviso, rodape, children, rotulo }: {
  titulo: ReactNode;
  /** CPF ou o que houver no lugar dele, em mono. */
  documento?: ReactNode;
  /** Uma linha de apoio embaixo do documento (ex.: o e-mail e o telefone). */
  apoio?: ReactNode;
  selos?: ReactNode;
  aviso?: ReactNode;
  rodape?: ReactNode;
  children: ReactNode;
  /** Nome acessivel do cartao (o leitor de tela e o e2e acham a pessoa por ele). */
  rotulo?: string;
}) {
  return (
    <article className="mtc-fila-grupo" aria-label={rotulo}>
      <header className="mtc-fila-grupo__cabeca">
        <div className="mtc-fila-grupo__textos">
          <h2 className="mtc-fila-grupo__titulo">{titulo}</h2>
          {documento && <span className="mtc-fila-grupo__documento">{documento}</span>}
          {apoio && <span className="mtc-fila-grupo__apoio">{apoio}</span>}
        </div>
        {selos && <div className="mtc-fila-grupo__selos">{selos}</div>}
      </header>
      {aviso}
      <ul className="mtc-fila-grupo__itens">{children}</ul>
      {rodape && <p className="mtc-fila-grupo__rodape">{rodape}</p>}
    </article>
  );
}

/**
 * Um item do grupo. `tom="alerta"` pinta a borda: o que ninguem pode deixar de ver (ex.: conta bloqueada na corretora).
 * No celular os botoes descem pra baixo do titulo e ocupam a largura.
 */
export function ItemDoGrupo({ titulo, apoio, fatos, marcas, aviso, acoes, tom, rotulo }: {
  titulo: ReactNode;
  apoio?: ReactNode;
  fatos?: Fato[];
  /** Selos do que conferir. */
  marcas?: ReactNode;
  aviso?: ReactNode;
  acoes?: ReactNode;
  tom?: "alerta" | "erro";
  rotulo?: string;
}) {
  return (
    <li className="mtc-fila-item" data-tom={tom} aria-label={rotulo}>
      <div className="mtc-fila-item__cabeca">
        <div className="mtc-fila-item__textos">
          <strong className="mtc-fila-item__titulo">{titulo}</strong>
          {apoio && <span className="mtc-fila-item__apoio">{apoio}</span>}
        </div>
        {acoes && <div className="mtc-fila-item__acoes">{acoes}</div>}
      </div>
      {marcas && <div className="mtc-fila-item__marcas">{marcas}</div>}
      {fatos && fatos.length > 0 && <Fatos itens={fatos} />}
      {aviso}
    </li>
  );
}
